export function authUser(state) {
    return state.authUser;
}

export function firebaseAuthUser(state) {
    return state.firebaseAuthUser;
}
